angular.module('ticketco/common/arena').service('ArenaItemTypesService', ArenaItemTypesService);

function ArenaItemTypesService($http) {
  function url(id, promocode) {
    return "/events/" + id + "/seating_arrangement/item_types.json"
      + (promocode ? ("?promocode=" + promocode) : "");
  }

  function unwrapItemTypes(response) {
    return response.data.item_types;
  }

  return {
    get: function (eventId, promocode) {
      return $http.get(url(eventId, promocode))
        .then(unwrapItemTypes);
    }
  }

}
